import {
  addThumbsUp, 
  cancelThumbsUp, 
  addNoticeThumbsUp, 
  cancelNoticeThumbsUp, 
  addFaqThumbsUp, 
  cancelFaqThumbsUp,
} from '@/api/questions'

const useThumbsUp = () => {
  const handleThumbsUp = async (type: 'UGC' | 'FAQ' | 'NOTICE', sourceId: string, isCurrentThumbsUp: boolean, setList: any) => {
    const typeMap = {
      UGC: {
        questType: 'feedback',
        paramType: 'question',
        addApi: addThumbsUp,
        cancel: cancelThumbsUp
      },
      FAQ: {
        questType: 'faq',
        paramType: 'question',
        addApi: addFaqThumbsUp,
        cancel: cancelFaqThumbsUp
      },
      NOTICE: {
        questType: 'notice',
        paramType: 'notice',
        addApi: addNoticeThumbsUp,
        cancel: cancelNoticeThumbsUp
      },
    };
    if (isCurrentThumbsUp) {
      const res: any = await typeMap[type].cancel(sourceId)
      if (res.code === 200) {
        setList((prev: any) => {
          return prev.map((item: any) => {
            if (item.sourceId || item.id === sourceId) {
              item.currentUserIsThumbsUp = false
            }
            return item
          })
        })
      }
    } else {
      const res: any = await typeMap[type].addApi({
        sourceId,
        type: typeMap[type].paramType
      })
      if (res.code === 200) {
        setList((prev: any) => {
          return prev.map((item: any) => {
            if (item.sourceId || item.id === sourceId) {
              item.currentUserIsThumbsUp = true
            }
            return item
          })
        })
      }
    }
  }
  return {
    handleThumbsUp
  }
}

export default useThumbsUp;